@if (!naturalPersonOnly && !legalPersonOnly) {
  <div class="col-12">
    <gk-law-person-type-form
      [form]="lawPersonFormGroup"
    ></gk-law-person-type-form>
  </div>
}

@if (isNaturalPersonChosen()) {
  <gk-natural-person-simple-form
    [form]="getNaturalPersonFormGroup()"
    [submitted]="submitted"
  ></gk-natural-person-simple-form>
}

@if (isLegalPersonChosen()) {
  <gk-legal-person-simple-form
    [form]="getLegalPersonFormGroup()"
    [submitted]="submitted"
    [typeVisible]="typeVisible"
  ></gk-legal-person-simple-form>
}

@let addressFormGroup = getAddressFormGroup();
@if (addressFormGroup) {
  <gk-address-form
    [form]="addressFormGroup"
    [isRequired]="true"
  ></gk-address-form>
}

@let addressSelectFormGroup = getAddressSelectFormGroup();
@if (addressSelectFormGroup) {
  <gk-address-select-form
    [form]="addressSelectFormGroup"
  ></gk-address-select-form>
}

<gk-post-office-modal [addressFormGroup]="getAddressFormGroup()">
</gk-post-office-modal>
